module.exports = __webpack_public_path__ + "img/schema_siegemoule_6b.2bfa7f1a.svg";